import { getJSON, postJSON } from "@/lib/api"
import type { Story, StoriesPostBody } from "@yomimono/types"

export const getStories = async (params?: { limit?: number }) => {
  const url =
    params?.limit !== undefined
      ? `/v1/stories?limit=${params.limit}`
      : "/v1/stories"
  try {
    return await getJSON<Story[]>(url)
  } catch (err) {
    console.error("getStories failed:", err)
    throw err
  }
}

export const getStory = async (id: string) => {
  try {
    return await getJSON<Story>(`/v1/stories/${id}`)
  } catch (err) {
    console.error(`getStory(${id}) failed:`, err)
    throw err
  }
}

export const generateStory = async (payload: StoriesPostBody) => {
  try {
    return await postJSON<Story>("/v1/stories", payload)
  } catch (err) {
    console.error("generateStory failed:", err, payload)
    throw err
  }
}

export interface SubmitQuizResponse {
  correctIndices: number[]
}

export const submitQuiz = async (id: string, answers: (number | null)[]) =>
  postJSON<SubmitQuizResponse>(`/v1/stories/${id}/quiz`, { answers })
